import * as React from 'react';

export const CircleAddSlim = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M47 24C47 36.7026 36.7026 47 24 47C11.2975 47 1 36.7026 1 24C1 11.2975 11.2975 1 24 1C36.7026 1 47 11.2975 47 24Z"
      stroke="#646464"
      strokeWidth="2"/>
    <path
      d="M33 23H25V15H23V23H15V25H23V33H25V25H33V23Z"
      fill="#646464"
    />
  </svg>
);
